import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useState } from "react";
import { ACTION_TYPES } from "../constants";
import useResourcesUniversitySpacesContext from "views/Recursos/ResourcesUniversitySpaces/utils/context/useResourcesUniversitySpacesContext";
import { requestTakeStudentAttendanceInSpaceReservation } from "services/resources/universitySpaces/aboutUniversitySpaceResources";
import { getMinutesOfToday } from "components/CustomTimePicker/utils";

const useTakeStudentAttendance = ({
    selectedStudents, addActionTypeToListActions,
    reservation
}) => {
    const { loadingRequestOfReservationAction } = useResourcesUniversitySpacesContext();
    //#region Hooks
    const dialogTakeStudentsAttendanceConfirmation = useShowDialogAlert();
    const dialogCannotResponsibleTakeAttendanceUntilStartTime = useShowDialogAlert();
    //#endregion
    //#region States
    const [studentReservationDetailIdsForTakeAttendance, setStudentReservationDetailIdsForTakeAttendance] = useState([]);
    //#endregion
    //#region Functions
    const takeStudentAttendance = () => {
        dialogTakeStudentsAttendanceConfirmation.hide();
        setStudentReservationDetailIdsForTakeAttendance(selectedStudents.getReservationDetailsIdsOfStudentsSelected());
        selectedStudents.markForTakeAttendanceOnlySelectedStudents();
        selectedStudents.unselectAllStudents();
        addActionTypeToListActions(ACTION_TYPES.TAKE_ATTENDANCE);
    }
    function isOnSchedule() {
        const { timeStart, timeEnd } = reservation.schedule;
        const minutesOfToday = getMinutesOfToday();
        return minutesOfToday >= timeStart && minutesOfToday <= timeEnd;
    }
    const openTakeStudentAttendanceDialog = async () => {
        if (!isOnSchedule()) {
            dialogCannotResponsibleTakeAttendanceUntilStartTime.open();
            return;
        }
        dialogTakeStudentsAttendanceConfirmation.open();
    }
    const doRequestTakeStudentAttendance = async () => {
        loadingRequestOfReservationAction.show("Marcando asistencia...");
        const success = await requestTakeStudentAttendanceInSpaceReservation({
            reservationDetailIds: studentReservationDetailIdsForTakeAttendance
        });
        loadingRequestOfReservationAction.hide();
        if (!success) 
            throw new Error(true);
    }
    //#endregion
    return {
        fns: {
            takeStudentAttendance,
            openTakeStudentAttendanceDialog,
            doRequestTakeStudentAttendance
        },
        dialogs: {
            dialogTakeStudentsAttendanceConfirmation,
            dialogCannotResponsibleTakeAttendanceUntilStartTime
        }
    };
}

export default useTakeStudentAttendance;